import { md } from '@/utils/utils_html';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { GRID2D_BAR_generation_current_dimensions } from '../views_with_data/generation_current/GRID2D_BAR_generation_current_dimensions';
import { GRID2D_BAR_buttons } from './buttons/GRID2D_BAR_buttons';
import { GRID2D_BAR_viewers } from './viewers/GRID2D_BAR_viewers';

interface Props {
  entity: DTO__entity_with_grid2d;
  grid2d: DTO__grid2d;
  grid2d_virtual: DTO__grid2d_virtual;
  div_grid: HTMLDivElement;
}

export function GRID2D_BARS_bottom({ grid2d, entity, grid2d_virtual, div_grid }: Props) {
  /*
   * HTML
   */

  if (grid2d.is_stub()) return null;

  return (
    <>
      <div className={`absolute ${md(' bottom-0 right-0', ' bottom-1 left-1 ')} `}>
        <GRID2D_BAR_viewers {...{ entity }} />
        <GRID2D_BAR_generation_current_dimensions {...{ grid2d }} />
      </div>
      <div className={`absolute ${md(' bottom-0 right-0', ' bottom-1 right-1 ')} `}>
        <GRID2D_BAR_buttons {...{ entity, grid2d, grid2d_virtual, div_grid }} />
      </div>
    </>
  );
}
